<template>
  <div class="debug-container">
    <van-nav-bar title="VIP调试" left-arrow @click-left="goBack" />
    
    <div class="content">
      <h2>用户信息</h2>
      <div class="debug-section">
        <p><strong>用户ID:</strong> {{ user.id || '未知' }}</p>
        <p><strong>昵称:</strong> {{ user.nickname || '未知' }}</p>
        <p><strong>VIP等级:</strong> {{ user.vip_level || 0 }} ({{ vipText }})</p>
        <p><strong>VIP到期时间:</strong> {{ vipExpireText }}</p>
        <p><strong>剩余天数:</strong> {{ daysLeft }}</p>
      </div>

      <h2>套餐信息</h2>
      <div class="debug-section">
        <p><strong>套餐总数:</strong> {{ packages.length }}</p>
        <p><strong>可用套餐:</strong> {{ availablePackages.length }}</p>
        
        <div v-if="packages.length > 0">
          <h3>所有套餐:</h3>
          <div v-for="pkg in packages" :key="pkg.id" class="pkg-item">
            <p><strong>ID:</strong> {{ pkg.id }}</p>
            <p><strong>名称:</strong> {{ pkg.name }}</p>
            <p><strong>等级:</strong> {{ pkg.level }}</p>
            <p><strong>价格:</strong> ¥{{ pkg.price }}</p>
            <p><strong>状态:</strong> {{ pkg.status === 1 ? '启用' : '禁用' }}</p>
            <p><strong>可升级:</strong> {{ pkg.level > (user.vip_level || 0) ? '是' : '否' }}</p>
          </div>
        </div>
        
        <div v-if="availablePackages.length > 0">
          <h3>可升级的套餐:</h3>
          <div v-for="pkg in availablePackages" :key="pkg.id" class="pkg-item highlight">
            <p><strong>ID:</strong> {{ pkg.id }}</p>
            <p><strong>名称:</strong> {{ pkg.name }}</p>
            <p><strong>等级:</strong> {{ pkg.level }}</p>
            <p><strong>价格:</strong> ¥{{ pkg.price }}</p>
          </div>
        </div>
        
        <van-empty v-if="availablePackages.length === 0" description="没有可升级的套餐" />
      </div>

      <div class="actions">
        <van-button type="primary" block @click="loadPackages">刷新数据</van-button>
        <van-button type="warning" block @click="initPackages" style="margin-top: 10px;">初始化套餐</van-button>
        <van-button type="danger" block @click="fixUserData" style="margin-top: 10px;">修复用户数据</van-button>
        <van-button type="success" block @click="initDatabase" style="margin-top: 10px;">初始化数据库</van-button>
        <van-button type="info" block @click="goToUpgrade" style="margin-top: 10px;">去升级页面</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'DebugVip',
  data() {
    return {
      packages: [],
      loading: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user || {}
    },
    vipText() {
      const levels = {
        0: '免费体验',
        1: '冒险新星',
        2: '音乐勇者',
        3: '乐理大师',
        4: '音乐王者'
      }
      return levels[this.user.vip_level] || '免费体验'
    },
    vipExpireText() {
      if (!this.user.vip_end_time || this.user.vip_end_time === 0) {
        return this.user.vip_level > 0 ? '永久有效' : '未开通VIP'
      }
      const expireDate = new Date(this.user.vip_end_time * 1000)
      const year = expireDate.getFullYear()
      const month = (expireDate.getMonth() + 1).toString().padStart(2, '0')
      const day = expireDate.getDate().toString().padStart(2, '0')
      return `有效期至: ${year}-${month}-${day}`
    },
    daysLeft() {
      if (this.user.vip_end_time === 0 || this.user.vip_end_time === 2147483647) return '永久'
      const days = Math.ceil((this.user.vip_end_time - Math.floor(Date.now() / 1000)) / 86400)
      return Math.max(0, days)
    },
    availablePackages() {
      const currentLevel = this.user.vip_level || 0
      return this.packages.filter(pkg => {
        const pkgLevel = parseInt(pkg.level)
        return pkgLevel > currentLevel
      })
    }
  },
  async mounted() {
    await this.loadPackages()
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    async loadPackages() {
      this.loading = true
      try {
        const response = await this.$http.get('/api/vip/packages')
        console.log('API响应:', response.data)
        
        const packages = response.data.data.packages || []
        console.log('套餐数据:', packages)
        
        this.packages = packages.map(pkg => ({
          id: pkg.id,
          name: pkg.name,
          level: pkg.level,
          price: pkg.price,
          status: pkg.status
        }))
        
        console.log('处理后的套餐:', this.packages)
        console.log('当前VIP等级:', this.user.vip_level)
        console.log('可升级套餐:', this.availablePackages)
        
        this.loading = false
      } catch (err) {
        console.error('加载失败:', err)
        Toast.fail(err.message)
        this.loading = false
      }
    },
    async initPackages() {
      try {
        const response = await this.$http.post('/api/vip/packages/init')
        Toast.success('初始化成功')
        await this.loadPackages()
      } catch (err) {
        Toast.fail(err.message || '初始化失败')
      }
    },
    async fixUserData() {
      try {
        await this.$http.post('/api/user/fix')
        Toast.success('用户数据修复成功')
        await this.$store.dispatch('fetchUserInfo')
      } catch (err) {
        Toast.fail(err.message || '修复失败')
      }
    },
    async initDatabase() {
      try {
        await this.$http.post('/api/database/init')
        Toast.success('数据库初始化成功')
        await this.loadPackages()
        await this.$store.dispatch('fetchUserInfo')
      } catch (err) {
        Toast.fail(err.message || '初始化失败')
      }
    },
    goToUpgrade() {
      this.$router.push('/vip/upgrade')
    }
  }
}
</script>

<style scoped>
.debug-container {
  min-height: 100vh;
  background: #f8f9ff;
}

.content {
  padding: 20px;
}

h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #1a1a2e;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 16px 0 8px;
  color: #1a1a2e;
}

.debug-section {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.debug-section p {
  margin: 8px 0;
  color: #4a4a68;
  line-height: 1.6;
}

.debug-section strong {
  color: #1a1a2e;
  font-weight: 600;
}

.pkg-item {
  background: #f8f9ff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  border-left: 3px solid #667eea;
}

.pkg-item.highlight {
  background: #fff7e6;
  border-left-color: #fa8c16;
}

.actions {
  margin-top: 20px;
}
</style>
